import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import axios from "axios";
import { API } from "../App";

const DEFAULT_WHATSAPP_PHONE = "+1234567890";

// Friendly, sales-oriented predefined message
const PREDEFINED_MESSAGE = "Hello! I'm interested in Brendolly's Auto Parts products. Could you help me find the best part or deal for my car?";

const WhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState(DEFAULT_WHATSAPP_PHONE);

  useEffect(() => {
    // Fetch WhatsApp number from site settings
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/site-info`);
        if (response.data?.whatsapp) {
          setWhatsappNumber(response.data.whatsapp);
        }
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleClick = () => {
    // Clean the phone number (remove non-digits except leading +)
    const cleanedNumber = whatsappNumber.replace(/[^0-9+]/g, '').replace(/^\+/, '');
    const encodedMessage = encodeURIComponent(PREDEFINED_MESSAGE);
    window.open(`https://wa.me/${cleanedNumber}?text=${encodedMessage}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-24 right-6 z-50 bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-lg transition-all hover:scale-110 flex items-center justify-center whatsapp-bounce group"
      data-testid="whatsapp-btn"
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" fill="currentColor" />
      
      {/* Tooltip on hover */}
      <span className="absolute right-full mr-3 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us!
      </span>
    </button>
  );
};

export default WhatsAppButton;
